import { Product, ProductGroup } from '../../interfaces/products/shop'
import { ACTIONS } from '../actions/products'
import { ACTIONS as WISHLIST_ACTIONS } from '../actions/wishList'

interface ProductsReducerState {
  loading: boolean
  totalItems?: any
  latestProducts?: any
  loadingCumulative?: boolean
  currentSlug?: any
  currentSearch?: string | string[]
  isCumulative?: boolean
  error?: any
  filteredProducts?: Product[]
  filters?: any[]
  items: Partial<ProductGroup['items']>
  stock?: any[]
  likedProductsSet: Set<number>
  likedProducts: number[]
  wishList: Partial<ProductGroup['items']>
  wishListFetchedOnce: boolean
}

export const initialProductsState: ProductsReducerState = {
  loading: true,
  items: {
    items: [],
  },
  totalItems: [],
  filters: [],
  latestProducts: [],
  loadingCumulative: false,
  currentSlug: '',
  currentSearch: '',
  likedProducts: [],
  likedProductsSet: new Set(),
  wishList: {
    items: [],
  },
  wishListFetchedOnce: false,
}

const productsReducer = (
  state = initialProductsState,
  action
): ProductsReducerState => {
  switch (action.type) {
    case ACTIONS.GET_PRODUCTS_REQUEST:
    case ACTIONS.GET_LATEST_PRODUCTS_REQUEST:
      return { ...state, loading: true }
    case ACTIONS.GET_CUMULATIVE_PRODUCTS_REQUEST:
    case WISHLIST_ACTIONS.GET_WISH_LIST_REQUEST:
      return { ...state, loadingCumulative: true, loading: true }
    case ACTIONS.SET_CURRENT_SHOP_SLUG:
      return { ...state, currentSlug: action.slug }
    case ACTIONS.SET_CURRENT_SEARCH:
      return { ...state, currentSearch: action.search, currentSlug: '' }
    case ACTIONS.EMPTY_PRODUCTS:
      return { ...initialProductsState }
    case ACTIONS.GET_PRODUCTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        isCumulative: false,
        items: action.products,
      }
    }
    case ACTIONS.GET_CUMULATIVE_PRODUCTS_SUCCESS: {
      const cumulatedStock = [
        ...(!state.wishListFetchedOnce ? [] : state.items.items || []),
        ...(action.products.items || []),
      ]
      const uniqueProductsMap = new Map<number, Product>()
      cumulatedStock.forEach((product) => {
        uniqueProductsMap.set(product.id, product)
      })
      return {
        ...state,
        loading: false,
        isCumulative: action.products.page > 1,
        loadingCumulative: false,
        items: {
          limit: action.products.limit,
          page: action.products.page,
          pages: action.products.pages,
          total: action.products.total,
          items: Array.from(uniqueProductsMap.values()),
        },
        wishListFetchedOnce:
          action.type === WISHLIST_ACTIONS.GET_WISH_LIST_SUCCESS,
      }
    }
    case WISHLIST_ACTIONS.GET_WISH_LIST_SUCCESS: {
      const likedProducts = action.products.items.map((product) => product.id)
      return {
        ...state,
        loading: false,
        isCumulative: action.products.page > 1,
        loadingCumulative: false,
        wishList: action.products,
        wishListFetchedOnce: true,
        likedProductsSet: new Set(likedProducts),
        likedProducts,
      }
    }
    case WISHLIST_ACTIONS.CHECK_WISH_LIST_EXISTENCE_SUCCESS: {
      const likedProductsSet =
        Object.keys(action.productIds).length <= 1
          ? new Set(state.likedProductsSet)
          : new Set<number>()
      const likedProducts = [...state.likedProducts]
      Object.entries(action.productIds).forEach(([key, value]) => {
        if (value) {
          likedProductsSet.add(parseInt(key))
          likedProducts.push(parseInt(key))
        }
      })

      return {
        ...state,
        likedProductsSet,
        likedProducts,
      }
    }
    case ACTIONS.GET_LATEST_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        latestProducts: action.product_latest?.items,
      }
    case WISHLIST_ACTIONS.ADD_TO_WISH_LIST_SUCCESS: {
      const newLikedProducts = new Set(state.likedProductsSet)
      newLikedProducts.add(action.id)
      return {
        ...state,
        likedProductsSet: newLikedProducts,
        likedProducts: Array.from(newLikedProducts),
      }
    }
    case WISHLIST_ACTIONS.REMOVE_FROM_WISH_LIST_SUCCESS: {
      const newLikedProducts = new Set(state.likedProductsSet)
      newLikedProducts.delete(action.id)
      return {
        ...state,
        likedProductsSet: newLikedProducts,
        likedProducts: Array.from(newLikedProducts),
        wishList: {
          ...state.wishList,
          items: state.wishList.items.filter(
            (product) => product.id !== action.id
          ),
        },
      }
    }
    case ACTIONS.GET_PRODUCTS_FAILURE:
    case ACTIONS.GET_CUMULATIVE_PRODUCTS_FAILURE:
    case ACTIONS.GET_LATEST_PRODUCTS_FAILURE:
    case WISHLIST_ACTIONS.GET_WISH_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        loadingCumulative: false,
        error: action.err,
      }
    case WISHLIST_ACTIONS.RESET_WISH_LIST:
      return {
        ...state,
        wishListFetchedOnce: false,
      }
    default:
      return state
  }
}

export default productsReducer
